import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import Avatar from "../Avatar";
import Icon from "../Icon";
import Clock from "./Clock";
import EpiasLogo from "../../assets/img/epias-logo-white.svg";
import Turkey from "../../assets/img/turkey.svg";
import UK from "../../assets/img/united-kingdom.svg";
import { getMenuNotificationsRequest } from "../../redux/actions/notification";
import moment from "moment";
import { monthsAndResourceTypes } from "../../constants/translations";
import { API_POST, API_NOTIFICATION } from "../../helpers/api";
import { LANG_VALUES } from "../../helpers/convert";

export default function NavBar(props) {
  let { user, t } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const langRef = useRef(window.localStorage.getItem("i18nextLng"));
  const { roles, organization } = useSelector(
    (state) => state.authorization.user
  );
  const { menuList } = useSelector((state) => state.notification);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLangOpen, setIsLangOpen] = useState(false);
  const [lang, setLang] = useState();
  const [numberOfNotification, setNumberOfNotification] = useState(0);

  const translations = monthsAndResourceTypes(t);
  const redirectionObject = {
    BILATERAL_AGREEMENT_SEND: "/bilateral-agreement-operations",
    BILATERAL_AGREEMENT_RECEIVE: "/bilateral-agreement-operations",
    BILATERAL_AGREEMENT_APPROVAL: "/bilateral-agreement-operations",
    BILATERAL_AGREEMENT_PENDING_APPROVAL: "/bilateral-agreement-operations",
    BILATERAL_AGREEMENT_CANCEL: "/bilateral-agreement-operations",
    OBJECTION: "/objections",
    PROCESS_CHANGES: "",
    DOCUMENT_EXPORT: "/active-certificates",
    DOCUMENT_REPEAL: "/suspended-certificates",
    REPEAL_INFORMATION: "/suspended-certificates",
    REDEMPTION: "/redemption-operations-history",
    DOCUMENT_CANCEL: "/canceled-certificates",
    ORGANIZE_MARKET_MATCH_UP_INFORMATION: "/offers-and-matches",
    ORGANIZE_MARKET_CANCEL: "/offers-and-matches",
    GDDK: "/gddk-operations",
    LIMIT_OPERATIONS: "/user-parameters",
  };

  useEffect(() => {
    handleGetNumberOfNotification();
    const numberOfNotificationInterval = setInterval(() => {
      handleGetNumberOfNotification();
    }, 5000);
    return () =>
      numberOfNotificationInterval &&
      clearInterval(numberOfNotificationInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roles]);

  useEffect(() => {
    if (isMenuOpen) {
      dispatch(
        getMenuNotificationsRequest(
          organization && organization.organizationId
            ? organization.organizationId
            : null
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMenuOpen]);

  useEffect(() => {
    setLang(window.localStorage.getItem("i18nextLng"));
  }, []);

  const handleGetNumberOfNotification = () => {
    const url =
      organization && organization.organizationId
        ? `notification/organization/count/${organization.organizationId}`
        : `notification/admin/count`;
    if (process.env.REACT_APP_DISABLE_NOTIFICATION_CHECK === "false") {
      API_NOTIFICATION(url, "GET").then((res) => {
        setNumberOfNotification(res.data.count);
      });
    }
  };

  const handleRedirect = (path) => {
    history.push(path);
    setIsMenuOpen(false);
  };

  const switchLang = async (lang) => {
    if (langRef.current !== lang) {
      let res = await API_POST("system-parameter/parameter/lang", {
        lang: lang,
      });
      if (res.status === 200) {
        window.localStorage.setItem("i18nextLng", lang);
        window.location.reload();
      }
    }
  };

  return (
    <div className="km__c--navbar-container">
      <div className="km__c--navbar-left-section">
        <Link to="/" id="nav-logo">
          <img src={EpiasLogo} alt="EPİAŞ" />
          <span>{t("pages.default.top.title")}</span>
        </Link>
      </div>
      <div className="km__c--navbar-right-section">
        <Clock />

        <div
          className="km__c--avatar-wrapper"
          onBlur={() => setIsMenuOpen(false)}
          tabIndex="0"
        >
          <div
            className="km__c--navbar-notifications"
            onClick={() => setIsMenuOpen(true)}
          >
            {numberOfNotification ? (
              <span className="km__c--navbar-notifications-badge">
                {numberOfNotification > 9 ? "9+" : numberOfNotification}
              </span>
            ) : null}
            <Icon name="bell" color="#ffffff" />
          </div>
          <div
            className={`km__c--notification-menu-container ${
              isMenuOpen ? "km__c--notification-menu-is-open" : ""
            }`}
          >
            <div className="km__c--notification-menu-header">
              {t("pages.default.notifications.title")}
            </div>
            <div className="km__c--notification-menu-body">
              {menuList.map((item) => (
                <div
                  key={item.id}
                  className="km__c--notification-menu-item-container"
                  onClick={() => handleRedirect(redirectionObject[item.type])}
                >
                  <div>
                    <Icon name="file-text" />
                  </div>
                  <div className="km__c--notification-menu-item">
                    <div className="km__c--notification-menu-item-date">
                      {item.createdDate
                        ? `${moment(item.createdDate).format("DD")} ${
                            translations[moment(item.createdDate).format("M")]
                          } ${moment(item.createdDate).format(
                            "YYYY - HH:mm:ss"
                          )}`
                        : ""}
                    </div>
                    <div className="km__c--notification-menu-item-msg">
                      {item.message}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div
              className="km__c--notification-menu-footer"
              onClick={() => handleRedirect("/notifications")}
              id="nav-notifications"
            >
              {t("pages.default.notifications.showAllNotifications")}
            </div>
          </div>
        </div>
        <div
          className="km__c--avatar-wrapper km__c--avatar-is-lang"
          onBlur={() => setIsLangOpen(false)}
          tabIndex="0"
        >
          <div
            className="km__c--avatar-container"
            onClick={() => setIsLangOpen(true)}
          >
            <img src={lang === "en" ? UK : Turkey} alt={lang} />
          </div>
          <div
            className={`km__c--avatar-menu-container ${
              isLangOpen ? "km__c--avatar-menu-is-open" : ""
            }`}
          >
            <div
              className="km__c--avatar-menu-item"
              onClick={() => switchLang("en")}
              disabled={[LANG_VALUES.EN].includes(langRef.current)}
            >
              English
            </div>

            <div
              className="km__c--avatar-menu-item"
              onClick={() => switchLang("tr")}
              disabled={[LANG_VALUES.TR, LANG_VALUES.TRL].includes(
                langRef.current
              )}
            >
              Türkçe
            </div>
          </div>
        </div>
        <Avatar t={t} label={user.name} id="nav-avatar" />
      </div>
    </div>
  );
}
NavBar.propTypes = {
  hasNotification: PropTypes.bool,
  user: PropTypes.object.isRequired,
};
